<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>    

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <v-tab-item>
        <v-autocomplete
          v-model="leaveReport"
          label="Report Types"
          :items="reportTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />
        <report-leave-leave-report
          v-if="leaveReport === 'Leave Summary Report'"
          class="mb-2"
        />
        <report-leave-leave-summary-report
          v-if="leaveReport === 'Leave Reports by Individual'"
          class="mb-2"
        />
        <report-leave-subordinates-leave-summary-report
          v-if="leaveReport === 'Subordinates Leave Summary Report'"
          class="mb-2"
        />
        <report-leave-subordinates-approved-leave
          v-if="leaveReport === 'Subordinate Approved Leave Reports'"
          class="mb-2"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>      
</template>

<script>
  export default {
    components: {
      ReportLeaveLeaveReport: () => import('@/components/hris/reports/leaves/LeaveReport'),
      ReportLeaveLeaveSummaryReport: () => import('@/components/hris/reports/leaves/LeaveSummaryReport'),
      ReportLeaveSubordinatesLeaveSummaryReport: () => import('@/components/hris/reports/leaves/SubordinatesLeaveSummaryReport'),
      ReportLeaveSubordinatesApprovedLeave: () => import('@/components/hris/reports/leaves/SubordinateApprovedLeave'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Leave Reports' },
        ],
        active: 0,

        leaveReport: null,
        reportTypes: [
          ...(this.$hasPermissionTo(['generate approved leave report']) ? [{ name: 'Leave Summary Report' }] : []),
          ...(this.$hasPermissionTo(['generate leave summary report']) ? [{ name: 'Leave Reports by Individual' }] : []),
          ...(this.$hasPermissionTo(['generate subordinates leave summary report']) ? [{ name: 'Subordinates Leave Summary Report' }] : []),
          ...(this.$hasPermissionTo(['generate subordinates approved leave report']) ? [{ name: 'Subordinate Approved Leave Reports' }] : []),
        ],
      }
    },
  }
</script>
